import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';
import { store } from './store';

const router = createRouter({
    history: createWebHistory('/'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
                top: 100
            };
        }

        if (to.path !== from.path) {
            return { left: 0, top: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    // Reset errors at Route change
    store.commit('error/set', {});

    // Close all opened Popups
    store.commit('settings/closeAllPopups');
    store.commit('settings/closeAllSidebars');

    // Change Header Type in Settings Store depending on the Current Route
    to.path.startsWith('/dashboard') || to.path.includes('profile')
        ? store.commit('settings/setApplicationType', 'backend')
        : store.commit('settings/setApplicationType', 'frontend');

    // Set Backend Type in Settings depending on the Current Route
    if (to.path.startsWith('/dashboard')) {
        store.commit('settings/setBackendType', 'dashboard');
    } else if (to.path.startsWith('/profile')) {
        store.commit('settings/setBackendType', 'profile');
    }

    // Set Meta Description and Title for the current route
    const setMetaTags = (metaTags, path) => {
        const cleanedPath = path.replace('/', '');

        const metaTag = metaTags.data.find((tag) => tag.path.replace('/', '') === cleanedPath);

        // if no meta tag is found, use the first one as a fallback
        if (!metaTag) {
            // Set the Title in Header
            store.commit('settings/setHeaderName', to.meta.title);

            // Set Document Title
            const subPage = to.meta?.subPages?.find((subPage) => subPage.path === to.path);

            if (to.meta?.title) {
                subPage ? (document.title = to.meta?.title + ' - ' + subPage.name + ' | ' + 'HKCM') : (document.title = to.meta?.title + ' | ' + 'HKCM' || 'HKCM');
            }
        }

        if (metaTag) {
            // Cache DOM selections
            const descMeta = document.querySelector('meta[name="description"]');
            const titleMeta = document.querySelector('title');
            const ogTitleMeta = document.querySelector('meta[name="og:title"]');

            if (descMeta) descMeta.content = metaTag.description;

            if (titleMeta) {
                titleMeta.textContent = metaTag.title;
            }

            if (ogTitleMeta) {
                ogTitleMeta.content = metaTag.ogTitle || metaTag.title;
            }
        }
    };

    // Fetch meta tags from the store if not already fetched
    (async () => {
        let browserMetaData = store.getters['meta/get'];

        if (!browserMetaData?.data?.data?.length) {
            browserMetaData = await store.dispatch('meta/index');
        }

        if (browserMetaData?.data?.data?.length) {
            setMetaTags(browserMetaData.data, to.path);
        }
    })();

    //  Scroll to Top
    if (to.path !== from.path) {
        window.scrollTo(0, 0);
    }
    // --MB: Following code did NOT work on mobile!
    // window.scrollTo({
    //     top: 0,
    //     behavior: 'smooth'
    // })

    // If no Popup is open a redirect to Login Page
    if (!store.getters['settings/isAnyPopupOpen']) {
        to.matched.some((record) => record.meta.auth) && window.meta.authenticated === false ? [next('/login'), localStorage.setItem('next-page', to.path)] : next();
    }
});

router.afterEach((to, from) => {
    const toDepth = to.path.split('/').length;
    const fromDepth = from.path.split('/').length;
    to.meta.transition = toDepth < fromDepth ? 'slide-right' : 'slide-left';

    router.afterEach((to, from) => {
        sessionStorage.setItem('lastRoute', from.fullPath === '/' ? '/dashboard' : from.fullPath);
    });
});

export default router;
